import { FileItemDto } from '@models/file-item.model';
import { OceanTrackingData } from '@models/enhanced_tracking-data';

export class ShipmentFile {
  customer_po_number: string;
  file: FileItemDto;
}

export class AssociatedPos {
  purchase_order_id?: string;
  customer_po_number?: string;
  supplier_name?: string;

  constructor(data?) {
    Object.assign(this, data);
  }
}

export class ShipmentLineItem {
  id?: string;
  customer_po_number?: string;
  purchase_order_id?: string;
  shipment_tracking_id?: string;
  line_item_id: string;
  product_id?: string;
  total_ordered?: number;
  quantity_shipped: number;
  total_shipped_to_date?: number;
  name?: string;
}

export class Reference {
  reference_id: string;
  organization_id: string;
  shipment_tracking_id: string;
  name: string;
  color?: string;
}

export class Shipment {
  created_at: string;
  created_by: string;
  created_by_name: string;
  description: string;
  id: string;
  organization_id: string;
  name: string;
  file: ShipmentFile;
  files: ShipmentFile[];
  line_items: ShipmentLineItem[];
  link: string;
  purchase_order_id: string;
  shipped_at: string;
  arrives_at: string;
  tracking_code: string;
  references?: Reference[];

  enhanced_tracking_carrier_id?: string;
  enhanced_tracking_identifier_type?: string;
  enhanced_tracking_identifier?: string;

  enhanced_tracking_data: OceanTrackingData;
  associated_pos: AssociatedPos[];

  customer_po_number?: string;
  supplier_name?: string;

  is_lane_estimable?: boolean;

  constructor(data?) {
    Object.assign(this, data);
    if (data.enhanced_tracking_data) {
      this.enhanced_tracking_data = new OceanTrackingData(data.enhanced_tracking_data);
    }
    if (data.associated_pos) {
      this.associated_pos = data.associated_pos.map(a => new AssociatedPos(a));
    }
  }
}
